export const FORECAST_CALCULATION_CONSTANTS = {
  TURBINE_FETCH_SIZE: 10000,
  MIN_FORECAST_POPULATION: 10,
  PROGRESS_UPDATE_INTERVAL: 100,
  WORKER_TIMEOUT_MS: 300000,
} as const;